import React from 'react';
import webapi from '../../../api/webapi';
import Modal from 'react-bootstrap/Modal'


class SurfParagraphList extends React.Component{ 

    state = { modalshow: false};
    state = { modalHeader : '' }
    state = { modalText : '' }

    GetTextCode(ParagraphCode){
        if (window.getSelection)
        {
            //console.log(ParagraphCode);

            var selection = window.getSelection ();
            //console.log(selection);

            var start = selection.anchorOffset;
            var end = selection.focusOffset;
            //console.log(start);
            //console.log(end);
            this.setState({modalHeader: selection.anchorNode.textContent.substring(start,end)});

            var s = selection.anchorNode.textContent.substring(0,start);
            //console.log(s);
            
            var Sequence = ('000'+(s.length - s.replaceAll(" ", "").length + 1));
            Sequence=Sequence.substring(Sequence.length-3,Sequence.length) 
            //console.log(Sequence);

            var TextCode = ParagraphCode+Sequence
            //console.log(TextCode);

            return TextCode;

        }
    }

    showModal = async event => {
        event.preventDefault();
        
        var TextCode=this.GetTextCode(event.target.getAttribute('ParagraphCode'));
        
        //console.log("id:",event.target.id);
        //console.log("id:",this.state.modalshow);
        if (!this.state.modalshow)
        {
            //console.log("url:",'sentence/detail/'+event.target.id+'/null');
            const responseText= await webapi.get('sentence/detail/'+TextCode+'/null');
            this.setState({modalText:responseText.data});
            //alert(responseText.data);
            //this.setState({modalHeader: this.state.modalText.Transcription});
            //console.log("responseText:",responseText);
            if (responseText.data!=='')
                this.setState({modalshow: true});
            //alert(this.state.modalText);
        }
        else
        {
            this.setState({modalshow: false});
            this.setState({modalText: '' });
        }
        
        //console.log("modalText:",this.state.modalText);
        //this.setState({modalshow: true});
    };

    CloseModal = event => {
        event.preventDefault();
        this.setState({modalshow: false});
    }

    //const  SurfParagraphList = props => {
    render() {
        return (
            <div>
                <div class="alert" role="alert">
                    {this.props.pageData.length!==0 && this.props.pageData[0].F29905!== undefined?this.props.pageData[0].F29905:29905/*"برای مشاهده برچسب‌های واژه روی شماره کلیک کنید"*/}
                </div>
                {
                    this.props.ParagraphList.map((Paragraph) =>{
                    return  (
                            <div className="container-fluid" id="texts_main_content" key={Paragraph.Code}>
                                <div className="container">
                                    <div id="texts_main_content_body">
                                        {
                                            (Paragraph.Text!=="")
                                            ?
                                            <p className="right_align_pahlavi" ParagraphCode={Paragraph.Code} onDoubleClick={this.showModal}>
                                                {Paragraph.Text}
                                            </p>
                                            :
                                            null
                                        }
                                        <p className="left_align" ParagraphCode={Paragraph.Code} onDoubleClick={this.showModal}>
                                            {Paragraph.Sequence}- {Paragraph.Transcription}
                                        </p>
                                        {
                                            (Paragraph.Translation!=="")
                                            ?
                                            <p className="right_align" style={{fontFamily:"Tahoma",fontSize:"13px"}}>
                                                {Paragraph.Translation}
                                            </p>
                                            :
                                            null
                                        }
                                        {
                                            (Paragraph.EnTranslation!=="")
                                            ?
                                            <p className="left_align" style={{fontFamily:"Tahoma",fontSize:"13px"}}>
                                                {Paragraph.EnTranslation}
                                            </p>
                                            :
                                            null
                                        }
                                        {
                                            (Paragraph.Note!=="")
                                            ?
                                            <p id="texts_Note_content_body">
                                                {Paragraph.Note}
                                            </p>
                                            :
                                            null
                                        }
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
                {
                    (this.state.modalText) 
                    ?
                    (
                        <Modal
                            show={this.state.modalshow}
                            onHide={() => this.setState({modalshow: false})}
                            dialogClassName="modal-90w"
                            aria-labelledby="modal-styling-title"
                            centered
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="modal-styling-title">
                                    
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <table>
                                    <tbody>
                                    <tr>
                                            <td>
                                                <div className="Caption">Word:</div>
                                            </td>
                                            <td>
                                                <div className="rtlDataPahlavi">{this.state.modalText.Word}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="Caption">Transcription:</div>
                                            </td>
                                            <td>
                                                <div className="ltrData">{this.state.modalText.Transcription}</div>
                                                </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="Caption">Transliteration:</div>
                                            </td>
                                            <td>
                                                <div className="ltrData">{this.state.modalText.Transliteration}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="Caption">Translation1:</div>
                                            </td>    
                                            <td>    
                                                <div className="ltrDataFa">{this.state.modalText.Translation}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="Caption">Translation2:</div>
                                            </td>    
                                            <td>    
                                                <div className="ltrDataFa">{this.state.modalText.EnTranslation}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="Caption">Category:</div>
                                            </td>    
                                            <td>   
                                                <div className="ltrDataFa">{this.state.modalText.Category}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <div className="Caption">Lemma:</div>
                                            </td>    
                                            <td>    
                                                <div className="ltrData">{this.state.modalText.Lemma}</div>
                                            </td>
                                        </tr>
                                        <tr> 
                                            <td>
                                                <div className="Caption">Reference1:</div>
                                            </td>    
                                            <td>    
                                                <div className="ltrData">{this.state.modalText.Reference1}</div>
                                            </td>
                                        </tr>
                                        <tr>   
                                            <td>
                                                <div className="Caption">Reference2:</div>
                                            </td>    
                                            <td>     
                                                <div className="ltrData">{this.state.modalText.Reference2}</div>
                                            </td>
                                        </tr>
                                        <tr>   
                                            <td>
                                                <div className="Caption">Note:</div>
                                            </td>    
                                            <td>     
                                                <div className="ltrData">{this.state.modalText.Note}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                {/*
                                <br />
                                <div className="ltrData">
                                    {
                                        this.state.modalText.Paragraph.map((ParagraphItem,k) =>{
                                            return(
                                                (ParagraphItem.Text===this.state.modalHeader)
                                                ?
                                                    (<span className='HighLight' key={k}>{ParagraphItem.Text}</span>)
                                                :
                                                    (ParagraphItem.Text)
                                            )
                                        })
                                    }
                                </div>
                                 <br />
                                <div className="rtlDataFa">{this.state.modalText.ParagraphTranslation}</div>
                                <div className="rtlDataFaNote">{this.state.modalText.ParagraphNote}</div> */}
                            </Modal.Body>
                        </Modal>
                    )
                    :
                    null
                }
            </div>
        )
    }
}

export default SurfParagraphList;